import { Col } from "react-bootstrap";
import { ProjectInterface } from "../pages/Projects";
import '../styles/custom-styles.css'
import { renderTextBlock } from "./RenderTextBlocks";
import { useProjectTracker } from "../useProjectTracker";
import { ProjectCarousel } from "./ProjectCarousel";
import { GetProjectTypeString } from "./ProjectCard";
import ProjectImage from "./ProjectImage";
import { GitHub } from "@mui/icons-material";
import itchIcon from "../assets/img/itchio-textless-white.svg";
import GameLink from "./GameLink";
import { useMediaQuery } from "react-responsive";
import ProjectTabsRelated from "./ProjectTabsRelated";
import { getProjectsByNames } from "src/projects/ProjectLists";

interface ProjectBaseProps {
    project: ProjectInterface;
    useCarousel: boolean;
    isLeftFirst?: boolean;
    titleSize?: number;
    carouselData?: { image: string, caption: string }[];
    children?: React.ReactNode;
    leftContent?: React.ReactNode;
    rightContent?: React.ReactNode;
}

function setCSSVariable(name: string, value: string) {
    document.documentElement.style.setProperty(name, value);
}

export function ProjectBase({ project, useCarousel, carouselData, children, leftContent, rightContent, isLeftFirst = true, titleSize = -1 }: ProjectBaseProps) {
    useProjectTracker();
    const isMobile = useMediaQuery({ maxWidth: 537 });

    var projects = getProjectsByNames(project.relatedProjects ?? []);

    var roleString = "";
    var roles = project.roles;
    if (roles) {
        roleString = roles.join(", ");
    }

    var technologyString = "";
    var technologies = project.technologies;
    if (technologies) {
        technologyString = technologies.join(", ");
    }

    var collaboratorString = "";
    var collaborators = project.collaborators;
    if (collaborators) {
        collaboratorString = collaborators.join(", ");
    }

    if (project.highlightColor) {
        setCSSVariable("--project-highlight-color", project.highlightColor);
    }

    const findAndScrollToLinks = () => () => {
        const links = document.getElementsByClassName("a-top-link")[0];
        console.log(links);
        if (links) {
            links.scrollIntoView({ behavior: "smooth" });
        }
    };

    return (
        <div className="a-base">
            <div className="a-title">
                <div className="a-width">
                    <Col size={12} md={7} className="banner-col banner-col-left a-col-title-left">
                        <div className="a-title-title" style={isMobile ? { fontSize: "10vw" } : { fontSize: titleSize === -1 ? "3.4rem" : `${titleSize}rem` }}>
                            {project.title}
                        </div>
                        <div className="a-title-info">
                            <p className="a-title-author">{renderTextBlock(collaboratorString)}</p>
                            <p className="a-title-date">{project.year}</p>
                        </div>
                        <div className="a-title-desc">
                            {project.summary}
                        </div>
                        <div className="a-detail">
                            <div className="a-details-heading">
                                Roles:
                            </div>
                            <div className="a-details-detail">
                                {roleString}
                            </div>
                        </div>
                        <div className="a-detail">
                            <div className="a-details-heading">
                                Tools/Technology:
                            </div>
                            <div className="a-details-detail">
                                {technologyString}
                            </div>
                        </div>
                        <div className={"a-social-icon"}>
                            <button onClick={findAndScrollToLinks()}>
                                <p>Links</p>
                            </button>
                            {project.linkData.some((x: { type: string }) => x.type === 'github') ?
                                <a href={project.linkData.find(x => x.type === 'github')?.url} target="_blank" rel="noopener noreferrer"><GitHub /></a>
                                : null}

                            {project.linkData.some((x: { type: string }) => x.type === 'itchio') ?
                                <a href={project.linkData.find(x => x.type === 'itchio')?.url} target="_blank" rel="noopener noreferrer">
                                    <img src={itchIcon} alt="Itch.io" />
                                </a>
                                : null}
                        </div>
                    </Col>

                    <Col size={12} md={5} className="banner-col banner-col-right a-col-title-right">
                        {useCarousel ? (
                            <ProjectCarousel
                                data={carouselData || []}
                                title={project.title}
                                description={GetProjectTypeString(project.projectType)}
                            />
                        ) : (
                            <ProjectImage src={project.imageSrc} alt={project.title}
                                title={project.title}
                                description={GetProjectTypeString(project.projectType)} />
                        )}
                    </Col>
                </div>
            </div>

            <div className="a-top" style={children != null ? { boxShadow: "inset 0px 6px 6px -6px var(--color-opacity-background)", paddingBottom: "0" } : undefined}>
                <div className="a-left-container">
                    {isLeftFirst && leftContent}
                    <Col size={12} md={12} className="a-left">
                        <h4 className="a-subtitle">
                            {project.studio ? "Contributions" : project.descriptionTitle}
                        </h4>
                        <div className="a-description">
                            {renderTextBlock(project.description)}
                        </div>
                    </Col>
                    {!isLeftFirst && leftContent}
                </div>
            </div>

            {children}

            <div className="a-top-link" style={children != null ? { paddingBottom: "5rem" } : { paddingBottom: "5rem" }}>
                <Col size={12} md={12} sm={12} className="a-right-container">
                    <div className="a-right-no-bg">
                        <GameLink
                            gameName={project.title}
                            data={project.linkData} />
                    </div>
                    {/* <div className="a-right">
                        <div className="a-details-base">
                            <div className="a-detail">
                                <div className="a-details-heading">
                                    Roles
                                </div>
                                <div className="a-details-detail">
                                    {roleString}
                                </div>
                            </div>
                            <div className="a-detail">
                                <div className="a-details-heading">
                                    Year
                                </div>
                                <div className="a-details-detail">
                                    {project.year}
                                </div>
                            </div>
                            <div className="a-detail">
                                <div className="a-details-heading">
                                    Tools/Technology
                                </div>
                                <div className="a-details-detail">
                                    {technologyString}
                                </div>
                            </div>
                            <div className="a-detail">
                                {renderTextBlock(collaboratorString) && (
                                    <>
                                        <div className="a-details-heading">
                                            Development Team
                                        </div>
                                        <div className="a-details-detail">
                                            {renderTextBlock(collaboratorString)}
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div> */}
                    {rightContent}
                </Col>
            </div>

            {projects.length > 0 && (
                <ProjectTabsRelated mobileProjs={projects} webProjs={projects} />
            )}

        </div>
    );
}